/** @jsx jsx */
import { jsx } from 'theme-ui';
export var CountryDisplay = function (_a) {
    var className = _a.className, code = _a.code;
    return jsx("div", { className: className }, getCountryName(code));
};
export function getCountryName(code) {
    switch (code) {
        case 'JE':
            return 'Jersey';
        case 'GG':
            return 'Guernsey';
        default:
            return 'United Kingdom';
    }
}
//# sourceMappingURL=CountryDisplay.js.map